import i18next from "i18next";

export const rms2BasePath = process.env.RMS2_BASE_PATH;
export const baseUrl = process.env.BASE_PATH;

interface SessionAuthentication {
    tenantStringIdentifier: string,
    token: string
}

export function getSessionAuthentication(): SessionAuthentication {
    const auth = {
        tenantStringIdentifier: getCookie('X-JetsoftTenant')?.replace('22%', '') ?? '',
        token: getCookie('X-JetsoftToken')?.replace('%22', '') ?? ''
    };

    return auth;
}

export async function readTranslations(): Promise<Record<string, string>> {

  const languageKey = localStorage.getItem("NG_TRANSLATE_LANG_KEY");

  const response = await fetch(baseUrl + "localization/resources?lang=" + languageKey, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  if(!response.ok || response.body == null) {
    console.error(response);
    return {};
  } else {
    console.log(response);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let result = '';
  let resource: Record<string, string> = {};

  while(true) {
    const { done, value } = await reader.read();
    if (done) {
      break;
    }

    result += decoder.decode(value, {stream: true});
  }

  try {
    resource = JSON.parse(result);
  } catch (e) {
      console.error('Error reading translations: ' + e);
  }

  return resource;
}

function getCookie(name: string) {
    const cookieArr = document.cookie.split(';');
    for (const cookie of cookieArr) {
      const [key, value] = cookie.trim().split('=');
      if (key === name) {
        const decoded = decodeURIComponent(value);
        return decoded.replace(/^"(.+)"$/, '$1');
      }
    }
    return null;
  }

